import { Button } from "antd";
import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      type="default"
      shape="circle"
      size="large"
      icon={theme === "light" ? <MoonOutlined /> : <SunOutlined />}
      onClick={toggleTheme}
      className="flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      title={
        theme === "light" ? "Chuyển sang chế độ tối" : "Chuyển sang chế độ sáng"
      }
    />
  );
};

export default ThemeToggle;
